"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getStorefrontWidgetStatusAction,
  type StorefrontWidgetStoreView,
} from "@/server-actions/shopify/storefront-widget"

export const storefrontWidgetQueryKeyPrefix = ["shopify", "storefront-widget"] as const

export function useStorefrontWidgetStatusQuery(channelId: string) {
  return useQuery<StorefrontWidgetStoreView[]>({
    queryKey: [...storefrontWidgetQueryKeyPrefix, channelId],
    queryFn: async () => {
      const result = await getStorefrontWidgetStatusAction({ channelId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
